import React, { useRef } from 'react';
import {
  Box,
  Heading,
  Container,
  Body,
  HStack,
  Divider,
  Icon,
} from '@hover/blueprint';
import { iChevronLeft, iChevronRight } from '@hover/icons';
import Slider from 'react-slick';
import { PRICING_TO_MATCH_PROPERTY } from '../../../constants';
import { IPricingToMatch } from '../../../interfaces/IPricingToMatch';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const settings = {
  dots: false,
  infinite: true,
  speed: 1500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
};

const PricingToMatchMobile: React.FC = () => {
  const sliderRef = useRef<Slider>(null);

  const onNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const onPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <Container
      maxW="100%"
      px={0}
      d={{ base: 'block', tablet: 'none' }}
      mb={700}
    >
      <Heading textAlign="center" size={500} isLight marginBottom={700}>
        Which plan is right for you?
      </Heading>
      <HStack w="100%" justifyContent="center" spacing="107px" mb="54px">
        <Icon
          onClick={onPrev}
          strokeWidth="2px"
          size="default"
          color="primary.600"
          icon={iChevronLeft}
        />
        <Icon
          onClick={onNext}
          strokeWidth="2px"
          size="default"
          color="primary.600"
          icon={iChevronRight}
        />
      </HStack>
      <Box d="block" maxW="100%" overflow="hidden">
        <Slider ref={sliderRef} {...settings}>
          {PRICING_TO_MATCH_PROPERTY.map((match: IPricingToMatch) => (
            <Box key={match.id} flexDir="column" alignItems="center">
              <Box
                pt={400}
                flexDir="column"
                bg="brandBrown.100"
                shadow="distance300"
                borderRadius="8px"
                px={500}
                pb={400}
              >
                <Body
                  mx="auto"
                  isBold
                  size={600}
                  marginBottom={100}
                  color="neutral.600"
                >
                  {match.title}
                </Body>
                <Body mx="auto" isBold size={400} marginBottom={100}>
                  {match.facets}
                </Body>
                <Box mx="auto" mt={800}>
                  {match.image}
                </Box>
              </Box>
              <Box flexDir="column" bg="brandTan.100" pt="20px">
                <HStack px={600} spacing="auto" h="76px" alignItems="center">
                  <Heading size={200} fontWeight={700} marginBottom={0}>
                    ROOF-ONLY
                  </Heading>
                  <Heading size={500} fontWeight={700} marginBottom={0}>
                    ${match.roofOnly}
                  </Heading>
                </HStack>
                <Divider borderColor="neutral.400" />
                <HStack px={600} spacing="auto" h="76px" alignItems="center">
                  <Heading size={200} fontWeight={700} marginBottom={0}>
                    COMPLETE
                  </Heading>
                  <Heading size={500} fontWeight={700} marginBottom={0}>
                    ${match.complete}
                  </Heading>
                </HStack>
                <Divider borderColor="neutral.400" />
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Container>
  );
};

export default PricingToMatchMobile;
